import { emitterCreateSubscriber } from '@THC/utils/emitter';

import { useDerivedActionStateEmitter } from './useDerivedActionStateEmitter';

const subscribe = emitterCreateSubscriber(useDerivedActionStateEmitter);

export const subscribeUseDerivedActionStateDisableEvent = subscribe('enable');
export const subscribeUseDerivedActionStateEnableEvent = subscribe('disable');
export const subscribeUseDerivedActionStateSetEvent = subscribe('set');
